// extracted by mini-css-extract-plugin
export default {"Info":"Info_Info__3Z-oM","Info__Heading":"Info_Info__Heading__PxD7P","Info__SubHeading":"Info_Info__SubHeading__KRhLl"};